import React, { useState, useEffect } from 'react';
import './styles.css';

const MobileAccolades = ({ isDarkMode }) => {
    const [accoladesData, setAccoladesData] = useState([]);

    useEffect(() => {
        fetch('/data/accolades.json')
            .then(response => response.json())
            .then(data => setAccoladesData(data))
            .catch(error => console.error('Error fetching accolades data:', error));
    }, []);

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Accolades</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    {accoladesData.map((category, index) => (
                        <div key={index} className="mobile-card">
                            <div className="mobile-accolade-header">
                                <div className="mobile-accolade-icon">🏆</div>
                                <h3 className="mobile-card-title">{category.title}</h3>
                            </div>
                            <ul className="mobile-accolade-list">
                                {category.items && category.items.map((item, itemIndex) => (
                                    <li key={itemIndex} className="mobile-accolade-item">
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MobileAccolades;
